import { render, staticRenderFns } from "./ClientBlockHistory.vue?vue&type=template&id=7b50bd16"
import script from "./ClientBlockHistory.vue?vue&type=script&lang=js"
export * from "./ClientBlockHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports